import neo4j from 'neo4j-driver';

const uri = process.env.REACT_APP_NEO4J_URI;
const user = process.env.REACT_APP_NEO4J_USER;
const password = process.env.REACT_APP_NEO4J_PASSWORD;
const database = process.env.REACT_APP_NEO4J_DATABASE;

if (!uri || !user || !password) {
  console.error('Neo4j configuration is incomplete. Please check your .env file.');
}

export const neo4jDriver = neo4j.driver(
  uri,
  neo4j.auth.basic(user, password),
  {
    maxConnectionLifetime: 3 * 60 * 60 * 1000, // 3 hours
    maxConnectionPoolSize: 50,
    connectionAcquisitionTimeout: 2000, // 2 seconds
  }
);

// Export a session factory that always includes the correct database
export const getSession = () => neo4jDriver.session({ database: database || 'neo4j' });

// Verify connectivity
neo4jDriver.verifyConnectivity()
  .then(() => {
    console.log('Connected to Neo4j database:', uri);
    console.log('Using database:', database);
  })
  .catch((error) => {
    console.error('Failed to connect to Neo4j:', error);
  });

// Cleanup when component unmounts
window.addEventListener('beforeunload', () => {
  neo4jDriver.close();
});
